import z from "zod"

export const GetMessenger = z.object({
  "hub.mode": z.string(),
  "hub.verify_token": z.string(),
  "hub.challenge": z.string(),
})

export const MessengerWebhookAttachmentEnum = {
  image: "image",
  audio: "audio",
  video: "video",
  file: "file",
  template: "template",
  fallback: "fallback",
} as const

export const MessengerWebhookMessagingSchema = z.object({
  sender: z.object({ id: z.string() }),
  recipient: z.object({ id: z.string() }),
  timestamp: z.number().transform((e) => new Date(e)),
  message: z
    .object({
      mid: z.string(),
      text: z.string().nullish(),
      is_echo: z.boolean().optional(),
      app_id: z.union([z.number(), z.string()]).optional(),
      reply_to: z.object({ mid: z.string() }).optional(),
      attachments: z
        .array(
          z.object({
            type: z.string(),
            payload: z.object({ url: z.string().optional() }).nullish(),
          }),
        )
        .nullish(),
    })
    .optional(),
  read: z.object({ watermark: z.number() }).optional(),
})

export const MessengerWebhookFeedSchema = z.object({
  field: z.literal("feed"),
  value: z.object({
    item: z.string(),
    verb: z.string(),
    post_id: z.string().optional(),
    comment_id: z.string().optional(),
    message: z.string().optional(),
    from: z.object({ id: z.string(), name: z.string().optional() }).optional(),
  }),
})

export const MessengerWebhookSchema = z.object({
  object: z.literal("page"),
  entry: z.array(
    z.object({
      id: z.string(),
      messaging: z.array(MessengerWebhookMessagingSchema).optional(),
      changes: z
        .array(z.union([MessengerWebhookFeedSchema, z.object({ field: z.string() })]))
        .optional(),
    }),
  ),
})
